import React, { useEffect } from 'react';
import {Col, Row} from 'reactstrap';
import {connect} from "react-redux";

// components
import RestrictionForm from "./_form";
import RestrictionList from "./_list";
import {showLoader} from "../../../components/loader/loader";
import {ButtonNew} from "../../../components/buttons/buttonsActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";

// actions
import { setForm, setItem } from "../../../redux/actions/generalActions/formActions";
import {clearState as clearListState} from "../../../redux/actions/generalActions/listActions";
import {setApp, clearState } from '../../../redux/actions/generalActions/mainActions'

function Restriction (props) {
    const { loading } = props.mainProps

    useEffect(() => {
        return () => {
            props.clearState();
            props.clearListState()
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);
    },[]);


    const createItem = () => {
        props.setItem(null);
        props.setForm();
        ModalFormContainer( RestrictionForm, {  } )
    }

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        <div className="ml-auto paddingAdd">
                            <ButtonNew onClick={createItem}/>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <RestrictionList  />
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearListState,
    clearState,
    setForm,
    setApp,
    setItem
});

export default connect(mapStateToProps, mapActionsToProps)(Restriction)